import React from 'react';
import ImageDropzone from './ImageDropzone';

const DropzoneLogo = ({ onLogoDropHandler, logoPath }) => (
  <ImageDropzone
    inputName="logoImage"
    label="Logo Image"
    imagePath={logoPath}
    alt="Logo"
    onImageReady={onLogoDropHandler}
    prepareOptions={{ maxSize: 700, preservePng: true }}
  />
);

export default DropzoneLogo;
